import Vue from 'vue';

Vue.directive('mask-name', {
	inserted(el, binding) {
		el.addEventListener('keydown', (event) => {
			const regexp = /(?:(?![×Þß÷þø])[0-9a-zÀ-ÿ\-\s'])/gi;

			if (!regexp.test(event.key)) {
				el.value = el.value;
				event.preventDefault();
				triggerInputUpdate(el);
			}
		});
	},
	componentUpdated(el) {
		triggerInputUpdate(el);
	}
});

const trigger = (el, type) => {
	const e = document.createEvent('HTMLEvents');
	e.initEvent(type, true, true);
	el.dispatchEvent(e);
};

const triggerInputUpdate = (el) => {
	trigger(el, 'input');
};
